//  Make sure changes to the map are done in vueMapMusea.js aswell, this is the more compact map on the homepage

import Vue from './vueCommon';
import Fuse from 'fuse.js';
import { VueDropdownComponent } from './components/vue-dropdown';

import $ from 'jquery';

(function vueOffer() {

    const MOBILE_WIDTH_THRESHOLD = 820;

    window.googleCallbacks = window.googleCallbacks || {};
    window.googleCallbacks.vueOffer = vueOffer;

    const HTML_LANG = $('html').attr('lang').toLowerCase();
    const LOCALE = ['nl', 'fr'].indexOf(HTML_LANG) > -1 ? HTML_LANG : 'nl';

    const GOOGLE_API_KEY = 'AIzaSyBjQOyBc9zd7U0IL2aHppCmd0WmmoysbY8';

    const $vueOffer = $('#vue-offer');

    if (!$vueOffer.length) return;

    const isCovidMode = !!parseInt($vueOffer[0].dataset.covidMode, 10);

    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        return app.helpers.loadScript(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&language=${LOCALE}&region=BE&libraries=places&callback=googleCallbacks.vueOffer`);
    }

    const BOUNDS_SW_LAT = 49.5294835476;
    const BOUNDS_SW_LNG = 2.51357303225;
    const BOUNDS_NE_LAT = 51.4750237087;
    const BOUNDS_NE_LNG = 6.15665815596;

    const $window = $(window);
    const $html = $('html');
    const $body = $('body');

    const cardMixin = {
        props: {
            index: Number,
            item: Object,
            isMobileView: Boolean,
            shouldMapBeLoaded: Boolean,
            isLargeView: Boolean,
            isXLargeView: Boolean,

        },
        computed: {
            isFeatured() {
                return this.index < 4;
            },
            isLarge() {
                return this.index == 0 || this.index == 3;
            },
            imageHtml() {
                let imageWidth = 600;
                let imageHeight = 300;

                if (this.isXLargeView) {
                    if (this.index === 0 || this.index === 3) {
                        imageWidth = 1250;
                        imageHeight = 750;
                    }

                    if (this.index === 1 || this.index === 2) {
                        imageHeight = 750;
                    }
                } else if (this.isLargeView && this.isFeatured) {
                    imageWidth = 600;
                    imageHeight = 600;
                }

                if (this.item.coverPhoto) {
                    return `<img src="${this.item.coverPhoto.resizableURL}?crop=auto&maxwidth=${imageWidth}&maxheight=${imageHeight}" alt="">`;
                } else if (this.item.image) {
                    return `<img src="${this.item.image}?crop=auto&maxwidth=${imageWidth}&maxheight=${imageHeight}" alt="">`;
                } else {
                    return `
                        <svg width="${imageWidth}" height="${imageHeight}" viewBox="0 0 ${imageWidth} ${imageHeight}" xmlns="http://www.w3.org/2000/svg">
                            <path d="M71.164 70.503l-2.324-17.16-7.903 17.21H58.51l-7.9-17.204-2.292 17.154H40l4.507-29.798h8.198l7.016 16.214 7.063-16.214h8.198l4.466 29.798zM168.37 58.975v-18.27h8.39v18.118c0 2.913 1.877 4.794 4.618 4.794 2.74 0 4.618-1.881 4.618-4.794V40.704h8.39v18.271c0 7.331-5.412 12.282-13.008 12.282-7.596 0-13.008-4.95-13.008-12.282M229.869 70.503l-2.325-17.16-7.903 17.21h-2.426l-7.899-17.204-2.293 17.154h-8.319l4.507-29.798h8.198l7.016 16.214 7.063-16.214h8.198l4.466 29.798zM71.164 151.51l-2.324-17.16-7.903 17.21H58.51l-7.9-17.204-2.292 17.154H40l4.507-29.798h8.198l7.016 16.214 7.063-16.214h8.198l4.466 29.798zM83.74 139.983v-18.271h8.39v18.118c0 2.913 1.877 4.795 4.618 4.795 2.74 0 4.618-1.882 4.618-4.795v-18.118h8.39v18.271c0 7.33-5.412 12.281-13.008 12.281-7.596 0-13.008-4.95-13.008-12.281M192.226 141.889h8.47c0 2.128 1.64 3.164 3.512 3.164 1.72 0 3.362-.915 3.362-2.543 0-1.869-2.32-2.411-5.156-3.099-4.307-1.069-9.806-2.39-9.806-9.174 0-5.867 4.313-9.23 11.339-9.23 7.144 0 11.241 3.668 11.241 9.731h-8.233c0-1.885-1.404-2.768-3.107-2.768-1.462 0-2.868.634-2.868 2.024 0 1.693 2.246 2.253 5.052 2.958 4.386 1.13 10.12 2.596 10.12 9.402 0 6.507-5 9.885-11.92 9.885-7.293 0-12.006-3.855-12.006-10.35"/>
                            <path d="M83.74 58.975v-18.27h8.39v18.118c0 2.913 1.877 4.794 4.618 4.794 2.74 0 4.618-1.881 4.618-4.794V40.704h8.39v18.271c0 7.331-5.412 12.282-13.008 12.282-7.596 0-13.008-4.95-13.008-12.282M114.62 60.881h8.47c0 2.129 1.641 3.165 3.512 3.165 1.721 0 3.363-.915 3.363-2.543 0-1.87-2.32-2.412-5.157-3.099-4.307-1.07-9.806-2.39-9.806-9.174 0-5.868 4.313-9.23 11.339-9.23 7.145 0 11.242 3.667 11.242 9.73h-8.234c0-1.884-1.404-2.768-3.107-2.768-1.461 0-2.867.634-2.867 2.024 0 1.693 2.247 2.254 5.051 2.959 4.386 1.13 10.12 2.596 10.12 9.402 0 6.506-5 9.885-11.918 9.885-7.295 0-12.008-3.856-12.008-10.35M163.124 63.382v7.121h-19.427V40.705h19.067V47.8h-10.893v4.388h9.786v6.733h-9.786v4.461zM65.424 91.974c0 6.25-4.707 10.802-11.04 10.802h-4.459v8.23h-8.228V81.208h12.687c6.333 0 11.04 4.517 11.04 10.766m-8.44.018c0-2.117-1.423-3.616-3.584-3.616h-3.475v7.232H53.4c2.16 0 3.584-1.497 3.584-3.616M85.701 106.167H75.139l-1.65 4.84h-8.798l11.705-29.798h8.026l11.96 29.798h-9.04l-1.641-4.84zM80.404 90.51l-3.265 9.233h6.558l-3.293-9.233zM97.421 101.385h8.47c0 2.129 1.641 3.164 3.513 3.164 1.72 0 3.362-.915 3.362-2.542 0-1.87-2.319-2.412-5.156-3.1-4.307-1.069-9.806-2.39-9.806-9.174 0-5.867 4.312-9.23 11.338-9.23 7.145 0 11.242 3.668 11.242 9.731h-8.234c0-1.885-1.404-2.768-3.107-2.768-1.461 0-2.867.634-2.867 2.024 0 1.693 2.247 2.253 5.051 2.958 4.386 1.131 10.121 2.596 10.121 9.402 0 6.507-5 9.885-11.92 9.885-7.294 0-12.007-3.855-12.007-10.35M125.05 101.385h8.47c0 2.129 1.64 3.164 3.512 3.164 1.72 0 3.362-.915 3.362-2.542 0-1.87-2.32-2.412-5.156-3.1-4.307-1.069-9.806-2.39-9.806-9.174 0-5.867 4.313-9.23 11.339-9.23 7.144 0 11.241 3.668 11.241 9.731h-8.233c0-1.885-1.404-2.768-3.107-2.768-1.462 0-2.868.634-2.868 2.024 0 1.693 2.246 2.253 5.052 2.958 4.386 1.131 10.12 2.596 10.12 9.402 0 6.507-5 9.885-11.918 9.885-7.295 0-12.008-3.855-12.008-10.35M114.62 141.889h8.47c0 2.128 1.641 3.164 3.512 3.164 1.721 0 3.363-.915 3.363-2.543 0-1.869-2.32-2.411-5.157-3.099-4.307-1.069-9.806-2.39-9.806-9.174 0-5.867 4.313-9.23 11.339-9.23 7.145 0 11.242 3.668 11.242 9.731h-8.234c0-1.885-1.404-2.768-3.107-2.768-1.461 0-2.867.634-2.867 2.024 0 1.693 2.247 2.253 5.051 2.958 4.386 1.13 10.12 2.596 10.12 9.402 0 6.507-5 9.885-11.918 9.885-7.295 0-12.008-3.855-12.008-10.35M163.124 144.39v7.12h-19.427v-29.797h19.067v7.095h-10.893v4.388h9.786v6.733h-9.786v4.46zM188.113 144.39v7.12h-19.428v-29.797h19.068v7.095H176.86v4.388h9.786v6.733h-9.786v4.46zM148.538 118.204l-1.245-4.198 11.018-4.535 1.218 6.347z"/>
                        </svg>
                    `;
                }
            }
        },
    };

    const cardMuseum = Vue.component('card-museum', {
        mixins: [ cardMixin ],
        template: `
            <a :href="item.detailUrl" class="card card--museum card--link" :class="{ 'is-featured': isFeatured, 'is-large': isLarge }">
                <div class="card__img" v-html="imageHtml"></div>
                <div class="card__main">
                    <h3 class="card__title" v-html="item.name"/>
                    <span class="label label--sml card__label" :class="{ 'label--danger': item.temporaryClosed }" v-if="${isCovidMode} || item.temporaryClosed">
                        {% item.temporaryClosed ? '${$vueOffer[0].dataset.langTemporaryClosed}' : '${$vueOffer[0].dataset.langTemporaryOpen}' %}
                    </span>
                    <div class="card__footer mt-xxs">
                        <div>
                            <div class="card__meta">
                                {% item.addressLocality %}<span v-if="item.themes"> - {% item.themes.join(', ') %}</span>
                            </div>
                            <div class="card__text" v-if="isLarge && item.shortDescription" v-html="item.shortDescription"/>
                        </div>
                    </div>
                </div>
            </a>
        `
    });

    const cardExpo = Vue.component('card-expo', {
        mixins: [ cardMixin ],
        template: `
            <a :href="item.detailUrl" class="card card--expo card--link" :class="{ 'is-featured': isFeatured, 'is-large': isLarge }">
                <div class="card__img">
                    <div v-html="imageHtml"></div>
                    <div class="card__tag" v-if="item.isLastChance">${$vueOffer[0].dataset.langOfferExpoLastChance}</div>
                </div>
                <div class="card__main">
                    <h3 class="card__title" v-html="item.name"/>
                    <span class="label label--sml card__label" :class="{ 'label--danger': item.temporaryClosed }" v-if="${isCovidMode} || item.temporaryClosed">
                        {% item.temporaryClosed ? '${$vueOffer[0].dataset.langTemporaryClosed}' : '${$vueOffer[0].dataset.langTemporaryOpen}' %}
                    </span>
                    <div class="card__meta" v-html="item.museum_name"/>
                    <div class="card__info" v-html="item.period"></div>
                    <div class="card__text" v-if="isLarge && item.description" v-html="item.description"/>
                    <div class="card__footer">
                        <div class="card__pricing" v-html="item.price"></div>
                    </div>
                </div>
            </a>
        `
    });

    let queryParams = {};

    if (location.search) {
        //  Parse query parameters, from https://stackoverflow.com/questions/8648892/convert-url-parameters-to-a-javascript-object
        queryParams = JSON.parse('{"' + decodeURI(location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
    }

    let instance = new Vue({
        el: $vueOffer[0],
        components: {
            dropdown: VueDropdownComponent,
            cardMuseum,
            cardExpo
        },
        props: {
            isCovidMode: {
                type: Boolean,
                default: () => isCovidMode
            },
        },
        data: {
            isMapInitialized: false,
            isLoading: true,
            isMobileView: false,
            shouldMapBeLoaded: false,
            isLargeView: false,
            isXLargeView: false,
            isMobileMapView: false,
            hasMapChanged: false,
            activeCategory: queryParams.activeCategory || 'museum',
            locationDescription: null,
            dropdownTextMuseum: null,
            dropdownTextLocation: null,
            searchResultsMuseum: [],
            searchResultsLocation: [],
            markers: [],
            userLocation: null,
            visibleItems: 10,
            queryParams,
            data: {
                museum: [],
                expo: []
            }
        },
        watch: {
            data: {
                deep: true,
                handler() {
                    this.updateMarkers();
                }
            },
            activeCategory() {
                this.updateMarkers();
                $window.trigger('resize');
            },
            visibleItems() {
                $window.trigger('resize');
            }
        },
        mounted() {
            this.optimizeQueryParams();

            this.updateData({}, true);

            $(window).on('popstate', event => {
                this.updateData(event.state);
            });

            this.initializeDropdownValues();

            //  Initialize google maps when not on mobile view
            if ($window.width() >= MOBILE_WIDTH_THRESHOLD) {
                this.shouldMapBeLoaded = true;
                this.initializeMap();
            }

            $window.on('resize', () => {
                $.doTimeout('_window_resize', 500, () => {
                    const isMobileView = $window.width() < MOBILE_WIDTH_THRESHOLD;
                    const isLargeView = $window.width() >= 1440;
                    const isXLargeView = $window.width() >= 1900;

                    instance.isMobileView = isMobileView;
                    instance.isLargeView = isLargeView;
                    instance.isXLargeView = isXLargeView;

                    if (!isMobileView) this.initializeMap();
                });
            });
        },
        methods: {
            optimizeQueryParams() {
                if (this.queryParams.hasOwnProperty('location')) {
                    /* occurs when the location was selected in the dropdown and the page is being refreshed
                       OR the location is an "input" param from another page */

                    if (!this.queryParams.hasOwnProperty('southwestLat')) {
                        /* occurs when the location is an "input" param from another page (without the map bounds being given) */

                        const locations = JSON.parse(this.$el.dataset.locations);
                        const activeLocation = locations.find((loc) => loc.name === this.queryParams.location);

                        if (activeLocation) {
                            /* adding map bounds to query params */
                            this.queryParams = {
                                ...this.queryParams,
                                southwestLat: activeLocation.southwest_lat,
                                southwestLng: activeLocation.southwest_lng,
                                northeastLat: activeLocation.northeast_lat,
                                northeastLng: activeLocation.northeast_lng,
                            };
                        } else {
                            /* removing location from query params */
                            this.queryParams = this.withoutLocationParam(this.queryParams);
                            this.syncQueryParamsWithBrowserLocation();
                        }
                    }
                }
            },

            initializeDropdownValues() {
                if (this.queryParams.hasOwnProperty('southwestLat')) {
                    if (this.queryParams.hasOwnProperty('location')) {
                        this.dropdownTextLocation = this.queryParams.location;
                    } else {
                        this.dropdownTextLocation = this.$el.dataset.langCustomViewport;
                    }
                }

                if (this.queryParams.hasOwnProperty('theme')) {
                    const themes = JSON.parse(this.$el.dataset.themes);

                    const activeTheme = themes.filter(theme =>
                        theme.id === this.queryParams.theme
                    )[0];

                    if (activeTheme) {
                        this.dropdownTextMuseum = activeTheme.name;
                    }
                }
            },

            getGoogleAutocompleteService() {
                if (!this.googleAutocompleteService) {
                    this.googleAutocompleteService = new google.maps.places.AutocompleteService();
                }
                return this.googleAutocompleteService;
            },

            getGooglePlacesService() {
                if (!this.googlePlacesService) {
                    if (this.map) {
                        this.googlePlacesService = new google.maps.places.PlacesService(this.map);
                    } else {
                        this.googlePlacesService = new google.maps.places.PlacesService(this.getMapElement());
                    }
                }
                return this.googlePlacesService;
            },

            shouldEnableMap() {
                return this.shouldMapBeLoaded;
            },

            getMapElement() {
                return document.getElementsByClassName('js-map')[0];
            },

            initializeMap() {
                if (!this.shouldEnableMap()) {
                    return;
                }

                if (this.isMapInitialized) return;
                this.isMapInitialized = true;

                this.defaultMapBounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(BOUNDS_SW_LAT, BOUNDS_SW_LNG),
                    new google.maps.LatLng(BOUNDS_NE_LAT, BOUNDS_NE_LNG)
                );

                this.map = new google.maps.Map(this.getMapElement(), {
                    animatedZoom: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_TOP
                    },
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    gestureHandling: 'greedy'
                });

                let initialMapBounds = this.defaultMapBounds;

                if (this.queryParams.hasOwnProperty('southwestLat')) {
                    initialMapBounds = new google.maps.LatLngBounds(
                        new google.maps.LatLng(this.queryParams.southwestLat, this.queryParams.southwestLng),
                        new google.maps.LatLng(this.queryParams.northeastLat, this.queryParams.northeastLng)
                    );
                }

                this.setMapBounds(initialMapBounds);

                this.infoWindow = new google.maps.InfoWindow();

                this.map.addListener('bounds_changed', () => {
                    this.hasMapChanged = true;
                });

                //  Sticky map
                (function () {
                    const $map = $('.js-map');
                    const $mapContainer = $map.parent();
                    const $mapSection = $mapContainer.closest('.section');

                    $mapSection.css({
                        position: 'relative'
                    });

                    const mapCssReset = {
                        position: 'relative',
                        bottom: 0,
                        left: 0,
                        right: 0
                    };

                    let mapCssFixed = {
                        position: 'fixed',
                        bottom: 0,
                        top: 0
                    };

                    let mapCssBottom = {
                        position: 'absolute',
                        bottom: 0,
                        top: 'auto'
                    };

                    let shouldMapStick;

                    $window.on('resize', () => {
                        $map.css({ opacity: 0 });
                        $mapContainer.css(mapCssReset);

                        $.doTimeout('window_resize', 500, () => {
                            const isMobileView = $window.width() < 820;
                            const isLargeView = $window.width() >= 1440;
                            const isXLargeView = $window.width() >= 1900;

                            let mapContainerOffsetLeft = $mapContainer.offset().left;

                            instance.isMobileView = isMobileView;
                            instance.isLargeView = isLargeView;
                            instance.isXLargeView = isXLargeView;

                            shouldMapStick = $mapContainer.height() < $mapSection.height() && !isMobileView;

                            const mapCss = {
                                left: mapContainerOffsetLeft,
                                right: $window.width() - (mapContainerOffsetLeft + $mapContainer.width())
                            };

                            mapCssFixed = {
                                ...mapCssFixed,
                                ...mapCss
                            };

                            mapCssBottom = {
                                ...mapCssBottom,
                                ...mapCss
                            };

                            setTimeout(() => {
                                $window.trigger('scroll');

                                $map.css({ opacity: 1 });
                            }, 100);
                        });
                    });

                    $window.on('scroll', () => {
                        if (!shouldMapStick) {
                            $mapContainer.css(mapCssReset);
                            return;
                        }

                        let scrollPosition = $window.scrollTop();
                        let mapSectionOffsetTop = $mapSection.offset().top;

                        let isMapFixed = mapSectionOffsetTop < scrollPosition;
                        let isMapBottom = mapSectionOffsetTop + $mapSection.height() < scrollPosition + $window.height();

                        if (isMapBottom) {
                            $mapContainer.css(mapCssBottom);
                        } else if (isMapFixed) {
                            $mapContainer.css(mapCssFixed);
                        } else {
                            $mapContainer.css(mapCssReset);
                        }
                    });
                })();

                //  Ask user geolocation
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    });
                }
            // });
            },

            clearNullParams(params) {
                if (params && typeof params === 'object') {
                    return Object.fromEntries(
                        Object.entries(params).filter(([key, val]) => val !== null),
                    );
                }

                return params;
            },

            /**
             * We store the location as a query param (so that we can keep showing the correct value in the location dropdown)
             * but the api itself does not use that param, so this function allows filtering out the location param WITHOUT actually
             * removing it from the queryParams object ...
             */
            withoutLocationParam(params) {
                if (params && typeof params === 'object') {
                    return Object.fromEntries(
                        Object.entries(params).filter(([key, val]) => key !== 'location'),
                    );
                }

                return params;
            },

            syncQueryParamsWithBrowserLocation(optionalParams) {
                const paramsToSync = optionalParams ?? this.queryParams;

                let newURL = `${location.origin}${location.pathname}`;

                if (Object.keys(paramsToSync).length) {
                    newURL += `?${$.param(paramsToSync)}`;
                }

                history.pushState(paramsToSync, '', newURL);
            },

            updateData(params, initial = false) {
                this.isLoading = true;

                if (typeof params !== 'undefined') {
                    this.queryParams = this.clearNullParams({
                        ...this.queryParams,
                        ...params
                    });
                }

                $.get(`/api/offer`, { ...(this.withoutLocationParam(this.queryParams)), locale: LOCALE }, data => {
                    if (!initial) {
                        this.syncQueryParamsWithBrowserLocation();
                    }

                    this.data.museum = data.musea || [];
                    this.data.expo = data.expos || [];

                    this.searchResultsMuseum = data.musea || [];

                    this.isLoading = false;

                    $window.trigger('resize');
                });
            },

            updateViewport(bounds, setBounds = true, isLocationReset = false) {
                if (!bounds) {
                    if (isLocationReset) {
                        this.resetLocation();
                    }

                    return;
                }

                if (setBounds && this.map) {
                    this.setMapBounds(bounds);

                    if (isLocationReset) {
                        this.resetLocation();
                    } else {
                        this.updateDataForCurrentViewport(false);
                    }
                } else {
                    if (isLocationReset) {
                        this.resetLocation();
                    } else {
                        const southWest = bounds.getSouthWest();
                        const northEast = bounds.getNorthEast();

                        this.updateData({
                            southwestLat: southWest.lat(),
                            southwestLng: southWest.lng(),
                            northeastLat: northEast.lat(),
                            northeastLng: northEast.lng()
                        });
                    }
                }
            },

            resetLocation() {
                this.updateData({
                    location: null,
                    southwestLat: null,
                    southwestLng: null,
                    northeastLat: null,
                    northeastLng: null,
                });
            },

            updateDataForCurrentViewport(changeDropdownText = true) {
                const bounds = this.map.getBounds();

                this.updateViewport(bounds, false);

                if (changeDropdownText) {
                    this.dropdownTextLocation = this.$el.dataset.langCustomViewport;
                    this.queryParams = this.withoutLocationParam(this.queryParams);
                    this.syncQueryParamsWithBrowserLocation();
                }
            },

            updateMarkers() {
                this.initializeMap();

                //  First remove existing markers
                this.markers.forEach(marker => {
                    marker.setMap(null);
                });

                this.markers = [];

                const addMarker = (item, infoWindowContent) => {
                    this.infoWindow && this.infoWindow.setContent(infoWindowContent);

                    let icon = '/frontend/img/svg/marker_default.svg';

                    if (this.isCovidMode) {
                        icon = item.temporaryClosed ? '/frontend/img/svg/marker_closed.svg' : '/frontend/img/svg/marker_open.svg';
                    }

                    let marker = new google.maps.Marker({
                        icon,
                        position: {
                            lat: item.latitude,
                            lng: item.longitude
                        },
                        map: this.map
                    });

                    marker.addListener('click', () => {
                        this.infoWindow && this.infoWindow.setContent(infoWindowContent);

                        this.infoWindow.open(this.map, marker);
                    });

                    this.markers.push(marker);
                };

                if (this.activeCategory === 'expo') {
                    let expoMarkers = {};

                    this.data[this.activeCategory].forEach(item => {
                        let infoWindowContent;

                        if (!expoMarkers.hasOwnProperty(item.museum_name)) {
                            expoMarkers[item.museum_name] = true;
                        } else return;

                        let label = '';

                        if (this.isCovidMode || item.temporaryClosed) {
                            const labelClass = `label label--sml ${item.temporaryClosed ? ' label--danger' : ''} card__label`;
                            const labelKey = item.temporaryClosed ? 'langTemporaryClosed' : 'langTemporaryOpen';
                            const labelText = this.$el.dataset[labelKey];

                            label = `
                                <span class="${labelClass}">
                                    ${labelText}
                                </span>`
                            ;
                        }

                        infoWindowContent = `
                            <div class="card card--infowindow">
                                <h3 class="card__title">${item.museum_name}</h3>
                                ${label}
                        `;

                        this.data[this.activeCategory]
                            .filter(expo => expo.museum_name === item.museum_name)
                            .forEach(expo => {
                                infoWindowContent += `
                                    <div class="card__section">
                                        <h4 class="card__title">
                                            <a href="${expo.detailUrl}">${expo.name}</a>
                                        </h4>
                                    </div>
                                `;
                            });

                        infoWindowContent += `</div>`;

                        addMarker(item, infoWindowContent);
                    });

                } else if (this.activeCategory === 'museum') {
                    let museumMarkers = {};

                    const getCoordKey = item => `${item.latitude.toFixed(3)} ${item.longitude.toFixed(3)}`;

                    this.data[this.activeCategory].forEach(item => {
                        let infoWindowContent;

                        const coordKey = getCoordKey(item);

                        if (!museumMarkers.hasOwnProperty(coordKey)) {
                            museumMarkers[coordKey] = true;
                        } else return;

                        infoWindowContent = `
                            <div class="card card--infowindow">
                        `;

                        this.data[this.activeCategory]
                            .filter(museum => getCoordKey(museum) === coordKey)
                            .forEach(museum => {
                                let label = '';

                                if (this.isCovidMode || museum.temporaryClosed) {
                                    const labelClass = `label label--sml ${museum.temporaryClosed ? ' label--danger' : ''} card__label`;
                                    const labelKey = museum.temporaryClosed ? 'langTemporaryClosed' : 'langTemporaryOpen';
                                    const labelText = this.$el.dataset[labelKey];

                                    label = `
                                        <span class="${labelClass}">
                                            ${labelText}
                                        </span>`
                                    ;
                                }

                                infoWindowContent += `
                                    <div class="card__section">
                                        <h3 class="card__title">
                                            <a href="${museum.detailUrl}">${museum.name}</a>
                                        </h3>
                                        ${label}
                                        <div class="card__meta">
                                            <div>${museum.addressLocality}</div>
                                            <div>${museum.themes.join(', ')}</div>
                                        </div>
                                    </div>
                                `;
                            });

                        infoWindowContent += `</div>`;

                        addMarker(item, infoWindowContent);
                    });
                }
            },

            getSearchItems() {
                return this.data[this.activeCategory].map(item => item);
            },

            getGridItemClass(index) {
                if (index == 0 || index == 3) {
                    return 'grid--bp-xxxl__8';
                }

                return 'grid--bp-xxxl__4';
            },

            setActiveCategory(activeCategory) {
                this.activeCategory = activeCategory;
                this.visibleItems = 10;

                // Reset sort parameter if it's not applicable to the new category
                const oldSort = this.queryParams.sort;

                // Sort values specific to each category
                const museumOnlySorts = ['alphabetically', 'created'];
                const expoOnlySorts = ['onlyLastChance', 'onlyNewEvents'];

                if (activeCategory === 'museum' && expoOnlySorts.includes(oldSort)) {
                    delete this.queryParams.sort;
                }

                if (activeCategory === 'expo' && museumOnlySorts.includes(oldSort)) {
                    delete this.queryParams.sort;
                }

                const newQueryParams = {
                    ...this.queryParams,
                    activeCategory
                };

                // Update sort if it's applicable to the new category, else only update URL without updating data
                if (this.queryParams.sort !== oldSort) {
                    this.updateData(newQueryParams);
                } else {
                    this.queryParams = newQueryParams;
                    this.syncQueryParamsWithBrowserLocation(newQueryParams);
                }
            },

            setMapBounds(bounds, showOnMobile=false) {
                const mapDiv = this.map.getDiv();
                if (!mapDiv) return;

                mapDiv.style.visibility = 'hidden';
                if(showOnMobile){
                    mapDiv.style.visibility = 'visible';
                }

                google.maps.event.addListenerOnce(this.map, 'idle', () => {
                    mapDiv.style.visibility = 'visible';
                    this.hasMapChanged = false;
                });

                this.map.fitBounds(bounds, 0);
            },

            fitUserLocation(isUserScrolling) {
                if (isUserScrolling) {
                    return;
                }

                //  Set bounds around user location (about a 50km square area)
                this.setMapBounds(new google.maps.LatLngBounds(
                    new google.maps.LatLng(this.userLocation.lat() - 0.25, this.userLocation.lng() - 0.25),
                    new google.maps.LatLng(this.userLocation.lat() + 0.25, this.userLocation.lng() + 0.25)
                ));

                this.updateDataForCurrentViewport();
            },

            handleMuseumListItemChange(listItem) {
                this.dropdownTextMuseum = listItem.name;

                this.updateData({
                    theme: listItem.id
                });
            },

            handleMuseumSearchItemChange(searchItem) {
                this.dropdownTextMuseum = searchItem.name;
                this.isLoading = true;

                window.location = searchItem.detailUrl;
            },

            handleMuseumInputChange(input) {
                if (!input) {
                    this.searchResultsMuseum = this.data.museum;
                    return;
                }

                const fuse = new Fuse(this.data.museum, {
                    keys: ['name']
                });

                this.searchResultsMuseum = fuse.search(input);
            },

            handleMuseumReset() {
                this.dropdownTextMuseum = null;

                this.updateData({
                    theme: null
                });
            },

            handleNoResults(searchText) {
                this.dropdownTextMuseum = searchText;

                this.data.museum = [];
                this.data.expo = [];
            },

            handleLocationListItemChange(listItem) {
                this.dropdownTextLocation = listItem.name;
                this.queryParams = {
                    ...this.queryParams,
                    location: listItem.name,
                };

                this.updateViewport(new google.maps.LatLngBounds(
                    new google.maps.LatLng(listItem.southwest_lat, listItem.southwest_lng),
                    new google.maps.LatLng(listItem.northeast_lat, listItem.northeast_lng)
                ));

                this.locationDescription = listItem.description;
            },

            handleLocationSearchItemChange(searchItem) {
                this.dropdownTextLocation = searchItem.name;

                this.initializeMap();

                this.getGooglePlacesService().getDetails({
                    fields: ['geometry'],
                    placeId: searchItem.placeId
                }, (result, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        this.updateViewport(result.geometry.viewport);
                    }
                });

                this.locationDescription = null;
            },

            handleLocationInputChange(input) {
                if (!input) {
                    this.searchResultsLocation = [];
                    return;
                }

                $.doTimeout('debounce', 500, () => {
                    this.initializeMap();

                    this.getGoogleAutocompleteService().getPlacePredictions({
                        bounds: this.defaultMapBounds,
                        componentRestrictions: {
                            country: 'be'
                        },
                        input: input,
                        types: ['(regions)']
                    }, (results, status) => {
                        if (status === google.maps.places.PlacesServiceStatus.OK) {
                            this.searchResultsLocation = results.map(result => ({
                                name: result.description,
                                placeId: result.place_id
                            }));
                        }
                    });
                });
            },

            handleLocationReset() {
                this.dropdownTextLocation = null;

                this.updateViewport(this.defaultMapBounds, true, true);

                this.locationDescription = null;
            },

            loadMore() {
                this.visibleItems = this.visibleItems + 12;

                $window.trigger('resize');
            },

            toggleMobileMapView() {
                this.isMobileMapView = !this.isMobileMapView;

                if (this.isMobileMapView && !this.shouldMapBeLoaded) {
                    this.shouldMapBeLoaded = true;
                }
                this.initializeMap();

                let bounds = this.defaultMapBounds;

                if (this.queryParams.southwestLat) {
                    bounds = new google.maps.LatLngBounds(
                        new google.maps.LatLng(this.queryParams.southwestLat, this.queryParams.southwestLng),
                        new google.maps.LatLng(this.queryParams.northeastLat, this.queryParams.northeastLng)
                    );
                }

                this.setMapBounds(bounds, this.isMobileMapView);
                this.updateViewport(bounds, false);

                if (this.isMobileMapView) {
                    window.scrollTo(0, 0);
                }

                $body.toggleClass('is-fixed', this.isMobileMapView);

                $('#launcher').toggle(!this.isMobileMapView);
            }
        }
    });
})();
